import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const MicklehamCdbsDentistPage = () => (
  <ServiceLocationTemplate suburbName="Mickleham" suburbSlug="mickleham" variant="cdbs-dentist" />
);

export default MicklehamCdbsDentistPage;
